/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
  query SenderRoutePlanReadQuery($routeId: ID!, $mccNameToSearch: String, $mncNameToSearch: String, $operatorNameToSearch: String, $countryNameToSearch: String, $take: PositiveInt, $skip: Int, $filter: JSONObject) {
    SenderRoutePlanRead(routeId: $routeId, mccNameToSearch: $mccNameToSearch, mncNameToSearch: $mncNameToSearch, operatorNameToSearch: $operatorNameToSearch, countryNameToSearch: $countryNameToSearch, filter: $filter, take: $take, skip: $skip) {
      id
      createdAt
      updatedAt
      message
      status,
      _totalCount,
      VendorAccount {
        id,
        displayName
      },
      Mcc {
        createdAt,
        updatedAt,
        mcc,
        countryName,
        dialingCode
      },
      Mnc {
        createdAt,
        updatedAt,
        mnc,
        network
      }
      SenderRoute {
        id
        displayName
      }
    }
  }
`
